<div class="column__wrapper">
  <ng-content></ng-content>
</div>
